<div class="loading" [ngClass]="{'animate': loadingComplete}" *ngIf="!removeLoader">
    <div class="image">
        <img src="../../../assets/images/logo-ring.png" alt="Bayer" class="ring">
        <img src="../../../assets/images/logo.svg" alt="Bayer" class="logo">
    </div>
</div>
